import React from 'react'
import Helmet from 'react-helmet'

import StandardWrapper from '../components/standardWrapper'

const links = Object.entries({
    "Wikipedia Deutschland Benutzer": "https://de.wikipedia.org/wiki/Benutzer:Birkenstab",
    "Sourcer Profile": "https://sourcerer.io/Birkenstab",
}).map(entry => ({ text: entry[0], url: entry[1] }))

const Links = () => (
    <StandardWrapper>
        <Helmet
            title="Links – Birkenstab"
            meta={[
                { name: 'keywords', content: 'links, link' }
            ]}
        />
        <h1>Links</h1>
        <ul>
            {
                links.map(link => (
                    <li key={link.url}><a href={link.url}>{link.text}</a></li>
                ))
            }
        </ul>
    </StandardWrapper>
)

export default Links



// WEBPACK FOOTER //
// ./src/pages/links.js